module.exports = __webpack_public_path__ + "img/jigou4.b85691ef.png";